module.exports = __webpack_public_path__ + "3b46b18679817ce2df23a37a7ca4b16f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/roze.mp3
// module id = 38
// module chunks = 0